import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";

import { isPublicPage } from "@/utils/visualBuilder";

import { ENTITY } from "../constants";
import { useUrlParams } from "./useUrlParams";
import { getBranding } from "../store/actions";

export function useBrandingData(props) {
  const { propertyId, userId } = props;
  const { tabStatus } = useUrlParams();

  const dispatch = useDispatch();
  const timer = useRef(null);

  const fetchBranding = () => {
    if (timer.current) {
      clearTimeout(timer.current);
    }

    timer.current = setTimeout(() => {
      dispatch(getBranding(propertyId, userId, isPublicPage(tabStatus)));
    }, 300);
  };

  useEffect(() => {
    if (propertyId) {
      fetchBranding();
    }
  }, [propertyId]);

  useEffect(() => {
    if (propertyId) {
      const listener = () => fetchBranding();

      const entities = [ENTITY.BRANDING];

      entities.forEach((entity) => document.addEventListener(entity, listener));
      return () => entities.forEach((entity) => document.removeEventListener(entity, listener));
    }
  }, [propertyId]);
}
